export enum MenuSelectedColaboradoresEnum {
  todos = "todos",
  bajas = "bajas",
  activos = "activos",
  listaNegra = "lista-negra",
}
export interface ActionMenuColaboradoresSelected {
  payload: MenuSelectedColaboradoresEnum;
}
